<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="jurisdictionsService"
    [idKey]="'jurisdictionId'"
></base-index-page>